import { Color, Spacing } from '@persona-id/design-tokens';
import { XIcon } from '@persona-id/design-tokens/icons';
import { noop } from 'lodash/fp';
import { ReactNode } from 'react';
import { BORDER_RADIUSES } from 'shared/styles/variables';
import styled from 'styled-components';

const Container = styled.div<{ color: string; isCompact: boolean }>`
  display: inline-flex;
  align-items: center;

  background: ${({ color }) => {
    return { purple: Color.CorePurple300, gray: Color.CoreSlate100, red: Color.CoreRed400 }[color];
  }};
  border-radius: ${BORDER_RADIUSES.rounded};
  margin: ${({ isCompact }) => {
    if (isCompact) {
      return `0 ${Spacing[2]} 0 0;`;
    }
    return `${Spacing[1]} ${Spacing[2]} ${Spacing[1]} 0;`;
  }};
  padding: 0 ${Spacing[2]};
  line-height: 150%;
  font-size: 12px;
  letter-spacing: 0.15px;
`;

const Clear = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: ${Spacing[1]};

  filter: brightness(100%);

  &:hover {
    filter: brightness(70%);
    transition: all 1s ease;
  }
`;

const Content = styled.div`
  overflow-wrap: break-word;
`;

interface PillProps {
  children: ReactNode;
  color: string;
  isCompact: boolean;
  clearable: boolean;
  handleClick?: (e: React.MouseEvent) => void;
  handleClear?: (e?: React.MouseEvent) => void;
}

const Pill = ({
  children,
  color,
  isCompact,
  clearable,
  handleClick = noop,
  handleClear = noop,
}: PillProps) => {
  return (
    <Container color={color} isCompact={isCompact}>
      <Content id='pill__content' onClick={handleClick}>
        {children}
      </Content>
      {clearable && (
        <Clear id='pill__clear-icon' onClick={handleClear}>
          <XIcon />
        </Clear>
      )}
    </Container>
  );
};

export default Pill;
